import { render, staticRenderFns } from "./project-custom-field.component.vue?vue&type=template&id=72f7f392&scoped=true&"
import script from "./project-custom-field.component.vue?vue&type=script&lang=ts&"
export * from "./project-custom-field.component.vue?vue&type=script&lang=ts&"
import style0 from "./project-custom-field.component.vue?vue&type=style&index=0&id=72f7f392&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7f392",
  null
  
)

export default component.exports